var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cz3__icon-button",class:{
        'cz3__icon-button--important': _vm.important,
        'cz3__icon-button--selected': _vm.selected,
    },attrs:{"disabled":_vm.disabled,"aria-label":_vm.label,"aria-selected":_vm.selected},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('span',{staticClass:"cz3__icon-button__icon"},[_vm._t("default"),_c('span',{staticClass:"cz3__icon-button__selected"})],2),_c('span',{staticClass:"cz3__icon-button__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }